import { render, staticRenderFns } from "./UserAvatar.vue?vue&type=template&id=75092062&"
import script from "./UserAvatar.vue?vue&type=script&lang=js&"
export * from "./UserAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75092062')) {
      api.createRecord('75092062', component.options)
    } else {
      api.reload('75092062', component.options)
    }
    module.hot.accept("./UserAvatar.vue?vue&type=template&id=75092062&", function () {
      api.rerender('75092062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/UserAvatar.vue"
export default component.exports